import { render } from "./Save.vue?vue&type=template&id=ee63f092"
import script from "./Save.vue?vue&type=script&lang=js"
export * from "./Save.vue?vue&type=script&lang=js"
script.render = render

export default script